import { AnimatePresence, motion } from "motion/react";
import { Portal } from "../portal";
import { Spinner } from "../spinner";

/** Props Interface */
interface SyncIndicatorProps {
	isSyncing: boolean;
}

export function SyncIndicator({ isSyncing }: SyncIndicatorProps) {
	return (
		<Portal>
			<AnimatePresence mode="wait">
				{isSyncing && (
					<motion.div
						className="right-4 bottom-4 z-50 fixed flex-center aspect-square card"
						initial={{ opacity: 0, scale: 0.8 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.8 }}
					>
						<Spinner size={5} />
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	);
}
